import { render, staticRenderFns } from "./FormatoPrueba.vue?vue&type=template&id=3cc5a568"
import script from "./FormatoPrueba.vue?vue&type=script&lang=js"
export * from "./FormatoPrueba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports